<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-group title="Temperature Monitoring" open>
      <vs-sidebar-item :to="'IndoorOverview'" index="1" icon="cloud_queue">
        Overview
      </vs-sidebar-item>
      <vs-sidebar-item
        v-if="user_role === 'admin'"
        :to="'IndoorReport'"
        index="2"
        icon="description"
      >
        Report
      </vs-sidebar-item>
      <!-- <vs-sidebar-item :to="'dnetdashboard'" index="3" icon="dashboard">
        Dashboard
      </vs-sidebar-item> -->
      <vs-sidebar-item :to="'/dnetlocationdashboard'" index="4" icon="room">
        Location
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/IndoorAlert'" index="4" icon="report_problem">
        Alert
      </vs-sidebar-item>

      <vs-sidebar-group v-if="user_role === 'admin'" title="Device Mangement">
        <vs-sidebar-item
          :to="'IndoorSensor'"
          index="2.2"
          icon="settings_remote"
        >
          Sensor
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
          Gateway
        </vs-sidebar-item>
        <vs-sidebar-item
          :to="'IndoorAlertSetting'"
          index="2.3"
          icon="new_releases"
        >
          Alert Setting
        </vs-sidebar-item>
      </vs-sidebar-group>
      <!-- <vs-sidebar-item :to="'/sensor'" index="2.1" icon="signal_cellular_alt">
          Device
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/gateway'" index="2.2" icon="settings_remote">
          Gateway
        </vs-sidebar-item> -->
    </vs-sidebar-group>

    <footer-sidebar slot="footer">
      <div class="footer-sidebar center">
        <div style="margin: 8px; text-align: center">
          <h5
            style="font-size: 0.8rem; font-weight: 550; color: rgb(91, 87, 119)"
          >
            Powered by<img
              class="ml-1"
              src="@/assets/images/logo/swift_logo (1).png"
              style="width: 30%"
            />
          </h5>
        </div>
      </div>
    </footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return { user_role: "" };
  },
  mounted() {
    // console.log();
    this.user_role = this.$session.get("role");
  },
};
</script>

<style>
</style>